import React, { useEffect, useState } from "react";
import ReactExport from "react-data-export";
import { useForm } from "react-hook-form";
import MetaTags from "react-meta-tags";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import Swal from "sweetalert2";
import api from "../../services/api";
import SelectList from "components/shared/select/select";
import { jwtDecode } from "jwt-decode";
import ExcelDmae from "components/shared/excel/excel";

const columnsLabel = {
  IDA: "IDA",
  NR_HIDROMETRO: "Num. Hidrômetro",
  DS_MODELO_HIDROMETRO: "Modelo Hidrômetro",
  DS_LOCALIDADE: "Localização",
  DT_RX_TIMED: "Data",
  DT_RX_TIMEH: "Hora",
  DS_TEMPERATURA: "Temperatura",
  NR_BASE_TEMPO: "Base Tempo",
  NR_BATERIA: "Bateria",
  NR_DIFERENCA_CONSUMO: "Consumo/Periodo",
  LEITURA_ATUAL: "Leitura"

}

const newdate = new Date();

const dateFim = (newdate.toISOString().slice(0, 10));
newdate.setDate(newdate.getDate() - 3);
const dateIni = (newdate.toISOString().slice(0, 10));

const dadosStorage = localStorage.getItem("dados");
const dados = (typeof dadosStorage === "string" && dadosStorage.trim() !== "") ? jwtDecode(dadosStorage) : "";
const ConsumoExterno = () => {
  const [consumptions, setConsumptions] = useState([]);
  const [pulses, setPulses] = useState([]);
  const [buscaHidrometro, setBuscaHidrometro] = useState(false);
  const [dadosConsumo, setDadosConsumo] = useState({ soma: 0, media: 0 });
  const [macro, setMacro] = useState({ value: "", label: "Selecione..." });
  const [hidrometer, setHidrometer] = useState('');

  useEffect(() => {
    const consumptionsMap = new Map();
    consumptions.forEach((consumption) => {
      const oldValues = consumptionsMap.get(consumption.pulse_id) || [];

      consumptionsMap.set(consumption.CD_META_DEVICE_ADDR, [
        consumption.NR_VLR_PULSO,
        ...oldValues,
      ]);
    });

    consumptionsMap.forEach((values, key) => {
      const newValues = values.map((value) => Number(value));

      const minPulse = Math.min(...newValues);
      const maxPulse = Math.max(...newValues);

      const pulseDifference = maxPulse - minPulse;
      consumptionsMap.set(key, pulseDifference);
    });

    consumptionsMap.forEach((value, key) => {
      setPulses((oldValues) => [
        oldValues.map((pulse) => ({
          ...pulse,
          id: key,
          value,
        })),
      ]);
    });
    api.get("/hydrometersmastercdmn/userexternal/" + dados.ID_EMPRESA).then((response) => {
      let data = [];
      let saneamento = [];
      response.data.map((elem) => {
        if (elem.NM_CONDOMINIO != null) {
          saneamento[elem.CD_LIGACAO_RGI_PRINCIPAL] = true;
        }
        data.push({
          value: elem.NR_HIDROMETRO,
          label: elem.DS_LOCALIDADE != null ? elem.DS_LOCALIDADE : "Localidade não cadastrada "
        });
      });
      if (data.length > 0) {
        setMacro(data);
      }
    });
  }, [consumptions]);

  const { register, handleSubmit } = useForm();
  const onSubmit = (data) => {
    data.NR_HIDROMETRO = hidrometer;
    if (
      data.NR_HIDROMETRO === "" ||
      data.DT_FILTER_INI === "" ||
      data.DT_FILTER_FIM === ""
    ) {
      Swal.fire({
        icon: "warning",
        text: "Por Favor Preencha todos os Campo",
      });
      return;
    }

    if (
      data.DT_FILTER_INI > data.DT_FILTER_FIM
    ) {
      Swal.fire({
        icon: "warning",
        text: "A data Fim não pode ser menor que a data Inicio",
      });
      return;
    }

    const dataIni = new Date(data.DT_FILTER_INI);
    const dataFim = new Date(data.DT_FILTER_FIM);
    const diffTime = Math.abs(dataFim - dataIni);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (diffDays > 31) {
      Swal.fire({
        icon: "warning",
        text: "O intervalo máximo de para consulta é de 30 dias",
      });
      return;
    }

    let oldValue = {};
    let oldLeitura

    const overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(0,0,0,0.5)';
    overlay.style.zIndex = '9999';
    overlay.style.display = 'flex';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.innerHTML = '<div style="color: white; font-size: 20px;">Aguarde...</div>';
    document.body.appendChild(overlay);

    api
      .post("/consumptions", data)
      .then((response) => {
        Swal.fire({
          icon: "success",
        });
        if (data.NR_HIDROMETRO !== "") {
          setBuscaHidrometro(true);
        } else {
          setBuscaHidrometro(false);
        }
        const result = [];
        let calc_leitura = 10;
          if(response.data[0].NR_VLR_PULSO == 1){
            calc_leitura = 1000
          }
          if(response.data[0].NR_VLR_PULSO == 100){
            calc_leitura = 10
          }
          if(response.data[0].NR_VLR_PULSO == 1000){
            calc_leitura = 1
          }
        for (let i = response.data.length - 1; i >= 0; i--) {
          const consumption = response.data[i];
        
            
          const newLeitura = consumption.NR_QUANTIDADE_LITROS
          const cons = (newLeitura - oldLeitura) || 0
          
          oldLeitura= newLeitura
                    const data = {
            ...consumption,
            DS_MODELO_HIDROMETRO: consumption.DS_MODELO_HIDROMETRO,
            DS_LOCALIDADE: consumption.DS_LOCALIDADE,
            NR_DIFERENCA_CONSUMO: cons > -30 ? cons : 0,
            NR_QUANTIDADE_LITROSMC: consumption.NR_QUANTIDADE_LITROS / 1000,
            LEITURA_ATUAL: parseInt((((parseInt(consumption.NR_VLR_PULSO * parseInt(consumption.NR_PULSO_LITROS))) / 1000) + parseInt(consumption.DS_RELOJOARIA_INICIAL))),
            DT_RX_TIMED: new Date(consumption.DT_RX_TIME).toLocaleDateString(),
            DT_RX_TIMEH: new Date(consumption.DT_RX_TIME).toLocaleTimeString(),

          };
          oldValue = data;

          result.push(data);
        }
        let soma = 0;
        result.map((elem) => {

          soma += elem.NR_DIFERENCA_CONSUMO > 0 ? elem.NR_DIFERENCA_CONSUMO : 0
        })
        soma = (soma / 1000)
        setDadosConsumo({ soma: soma, media: soma / result.length })
        setConsumptions(result.reverse());
        document.body.removeChild(overlay);

      })
      .catch(function (error) {
        document.body.removeChild(overlay);

        Swal.fire({
          icon: "warning",
          text: "Nenhum resultado encontrado, refaça a sua busca!",
        });
      });

  };
  const setColor = (color) => {

    color = parseInt(color)

    if (color == 100) {
      return "#228B22";
    } else if (color > 70) {
      return "#00FF7F"
    } else if (color > 35) {
      return "#f8722d"
    } else {
      return "#CD5C5C"
    }


  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Meu Consumo</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Meu Consumo</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    Bem vindo(a) ao IoT DMAE
                  </li>
                </ol>
              </Col>
            </Row>
          </div>
        </Container>

        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <form onSubmit={handleSubmit(onSubmit)} style={{ flex: 1 }}>
                    <Row className="mb-3">
                      <label
                        htmlFor="RGI_PRINCIPAL"
                        className="col-md-2 col-form-label"
                      >
                        Localidade
                      </label>

                      <div className="col-md-6">

                        <SelectList
                          options={macro}
                          onOptionSelect={(handleOptionSelect) => {
                            setHidrometer(handleOptionSelect);
                          }}
                        />
                      </div>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="DT_FILTER_INI"
                        className="col-md-2 col-form-label"
                      >
                        Data Início
                      </label>
                      <div className="col-md-6">
                        <input
                          {...register("DT_FILTER_INI", { required: true })}
                          className="form-control form-control-lg"
                          defaultValue={dateIni}

                          type="date"
                          name="DT_FILTER_INI"
                        />
                      </div>

                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="DT_FILTER_FIM"
                        defaultValue={dateFim}
                        className="col-md-2 col-form-label"
                      >
                        Data Final
                      </label>
                      <div className="col-md-6">
                        <input
                          {...register("DT_FILTER_FIM", { required: true })}
                          className="form-control form-control-lg"
                          type="date"
                          defaultValue={dateFim}
                          name="DT_FILTER_FIM"

                        />
                      </div>
                    </Row>
                    <Row className="mb-3">
                      <div className="button-items text-center">
                        <Button
                          color="secondary"
                          className="btn-lg"
                          type="submit"
                        >
                          Pesquisar <i className="dripicons-search" />
                        </Button>
                      </div>
                    </Row>
                  </form>

                  <div>
                    <div className="info-section mb-1">
                      <h2 className="text-primary mb-1">Consumo Período</h2>
                      <span className="text-muted d-block">
                        <i className="bx bx-loader bx-spin me-1"></i>
                        {buscaHidrometro ? dadosConsumo.soma + " M" : "Busque por alguma localidade"}
                      </span>
                    </div>

                    {/*<div className="info-section mb-1">
                      <h2 className="text-primary mb-1">Consumo Médio</h2>
                      <span className="text-muted d-block">
                        <i className="bx bx-loader bx-spin me-1"></i>
                        {buscaHidrometro ? dadosConsumo.media.toFixed(2) + " M" : "Busque por alguma localidade"}
                      </span>
                    </div>*/}

                    <div className="info-section">
                      <h2 className="text-primary mb-1">Leitura Atual</h2>
                      <span className="text-muted d-block" >
                        <i className="bx bx-loader bx-spin me-1"></i>
                        {consumptions[0] ? consumptions[0].LEITURA_ATUAL + " M" : "Busque por alguma localidade"}
                      </span>
                    </div>
                  </div>
                </div>

              </CardBody>
            </Card>
          </Col>
        </Row>

        <Container fluid>
          <Row>
            <Col lg={buscaHidrometro ? 7 : 12}>
              <div className="col-md-12 d-flex ">
                <Row className="col-md-10">
                  <br></br>
                  <ExcelDmae data={consumptions} name="Meu Consumo" columns={columnsLabel} />

                </Row>
              </div>
            </Col>
            <Col lg={12}> 
              <br></br>
            </Col>
          </Row>
          <div className="table-responsive">
            <table className="table align-middle table-nowrap mb-0">
              <thead className="table-light">
                <tr>
                  <th className="align-middle">IDA</th>
                  <th className="align-middle">Cód. Hidrômetro</th>
                  <th className="align-middle">Modelo Hidrômetro</th>
                  <th className="align-middle">Localização</th>
                  <th className="align-middle">Data</th>
                  <th className="align-middle">Hora</th>
                  <th className="align-middle">Vr. Pulso HD</th>
                  <th className="align-middle">Nr Pulso</th>
                  <th className="align-middle">Litros</th>
                  <th className="align-middle">Diferença/Consumo</th>
                </tr>
              </thead>
              <tbody>
                {consumptions?.map((consumption, key) => (
                  <tr key={"_tr_" + key}>
                    <td>{consumption.IDA}</td>
                    <td>{consumption?.NR_HIDROMETRO}</td>
                    <td>{consumption?.DS_MODELO_HIDROMETRO}</td>
                    <td>{consumption?.DS_LOCALIDADE}</td>
                    <td>
                      {new Date(consumption.DT_RX_TIME).toLocaleDateString()}
                    </td>
                    <td>
                      {new Date(consumption.DT_RX_TIME).toLocaleTimeString()}
                    </td>
                    <td>{consumption.NR_PULSO_LITROS}</td>
                    <td>{consumption.NR_VLR_PULSO}</td>
                    <td>{consumption.NR_QUANTIDADE_LITROS}</td>
                    <td>{consumption.NR_DIFERENCA_CONSUMO > 0 ? consumption.NR_DIFERENCA_CONSUMO : 0}</td>


                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ConsumoExterno;
